import React from 'react'
import ContentfulJsonLdBlocks from 'src/components/shared/ContentfulJsonLdBlocks'
import PropTypes from 'prop-types'
import Layout from 'src/components/layouts'
import FaqService from 'src/services/FaqService'
import FaqPage from 'src/components/pages/BrandPages/Faq'
import logger from 'src/common/logger'
import { getMegamenuData } from 'src/common/back/megamenu'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'

export async function getServerSideProps(context) {
  const { preview } = context
  const jsonLdSchemas = await getContentfulJsonLd('faq/')
  let megamenuData = null
  let faqs = []
  try {
    faqs = await FaqService.getInstance().getEnabledFaqs(preview)
    megamenuData = await getMegamenuData(context)
  } catch (error) {
    logger.error('FAQ page: can not get faqs', { error })
  }

  const faqsFinal = faqs.map((el) => {
    return {
      ...el,
      title: el.question,
      content: el.answer,
    }
  })
  delete faqsFinal.question
  delete faqsFinal.answer

  return {
    props: {
      jsonLdSchemas,
      faqs: faqsFinal,
      megamenuData: megamenuData || null,
    },
  }
}

const Faq = ({ faqs, megamenuData, jsonLdSchemas }) => {
  return (
    <>
      <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
      <Layout isBrandPage={true} megamenuData={megamenuData}>
        <FaqPage faqs={faqs} />
      </Layout>
    </>
  )
}

Faq.propTypes = {
  faqs: PropTypes.array.isRequired,
}

export default Faq
